import React from "react";
import PageBlockToolbarWrapper from "../page-block-toolbar-wrapper";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { IconSizes } from "atoms/constants/icon-sizes";
import { t } from "utilities/localization-utils";

interface ImageAnnotationToolbarProps {
    onCancel: () => void;
}

const CSS_CLASS_NAME = "c-image-annotation-toolbar";

const ImageAnnotationToolbar: React.FC<ImageAnnotationToolbarProps> = ({
    onCancel,
}) => {
    return (
        <div className={CSS_CLASS_NAME}>
            <PageBlockToolbarWrapper onCancel={onCancel} onDone={null}>
                <div className={`${CSS_CLASS_NAME}__content`}>
                    <Icon
                        cssClassName={`${CSS_CLASS_NAME}__image-action`}
                        size={IconSizes.Medium}
                        type={Icons.PencilPlus}
                    />

                    <span className={`${CSS_CLASS_NAME}__text`}>
                        {t("image-annotation-toolbar--label")}
                    </span>
                    <div className={`${CSS_CLASS_NAME}__separator`} />
                </div>
            </PageBlockToolbarWrapper>
        </div>
    );
};

export default ImageAnnotationToolbar;
